export enum UserRole {
    None = "",
    Operator = "operator",
    Supervisor = "supervisor",
    HR = "hr",
    Provider = "hses_provider",
    Client = "hses_client",
}